import * as React from 'react';
import { TopNavigation } from '@cloudscape-design/components';
import { logoSting } from '../../helpers/logoString';
import { UserContext } from '../../context/authContext';
import { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { INotes, tourNameEmun } from '../../lib/models/interfaces';
import Cookies from 'js-cookie';
import {
  Notification,
  useNotification
} from '../../context/notificationContext';
import { Mail, MailOpen, Settings } from 'lucide-react';
import { format } from 'date-and-time';

// const i18nStrings = {
//   overflowMenuBackIconAriaLabel: 'Back',
//   overflowMenuDismissIconAriaLabel: 'Close menu'
// };

export const TopNavigationBar = () => {
  const { logout, token, user, userM } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [showNotificationPanel, setShowNotificationPanel] = useState(false);
  const notificationPanelRef = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    let timer: NodeJS.Timeout;

    if (showNotificationPanel) {
      timer = setTimeout(() => {
        notifications.markNotificationsRead();
      }, 5000);
    }

    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showNotificationPanel]);

  React.useEffect(() => {
    setShowNotificationPanel(false);
  }, [location.pathname]);

  React.useEffect(() => {
    if (!showNotificationPanel) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (
        notificationPanelRef.current &&
        !notificationPanelRef.current.contains(event.target as Node)
      ) {
        setShowNotificationPanel(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showNotificationPanel]);

  const notifications = useNotification();

  const logoutLocal = (item: { detail: { id: string } }): void => {
    console.log('item ', item);
    if (item.detail.id === 'logout') {
      logout();
    }
    // if (item.detail.id === 'changePassword') {
    //   navigate('changepassword');
    // }
    if (item.detail.id === 'preferences') {
      navigate('user-preferences');
    }
    // if (item.detail.id === 'resetTours') {
    //   const allTourCookies = Object.values(tourNameEmun);
    //   for (const tour of allTourCookies) {
    //     Cookies.remove(tour);
    //   }
    // }
  };

  const ViewButton = (props: { notification: Notification }) => {
    const { notification } = props;
    let navigateTo = '';
    switch (true) {
      case notification?.documentId[0]?.documentType === 'analysis':
        navigateTo = `/app/simple-viewer?documentId=${notification?.documentId[0]._id}`;
        break;
      case notification?.documentId[0]?.documentType === 'GapAnalysis' ||
        notification?.documentId[0]?.documentType === 'rfp':
        navigateTo = `/app/rfp-upload?documentId=${notification?.documentId[0]?._id}`;
        break;
    }
    return (
      <button
        className="text-black bg-[#56dac5]/50  hover:bg-[#56dac5] text-md border border-black  rounded pl-2 pr-2"
        onClick={() => navigate(navigateTo)}
      >
        {`  View  `}
      </button>
    );
  };

  return (
    <>
      <TopNavigation
        className="b"
        identity={{
          href: '/app/landing',
          title: `${process.env.REACT_APP_TITLE}`,
          logo: { src: logoSting, alt: 'Service' }
        }}
        utilities={
          token
            ? [
                {
                  type: 'button',
                  iconName: `notification`,
                  title: 'Notifications',
                  ariaLabel: 'Notifications (unread)',
                  badge: notifications.showBadge,
                  disableUtilityCollapse: false,

                  onClick: () => {
                    setShowNotificationPanel((prev) => !prev);
                  }
                },
                {
                  type: 'menu-dropdown',
                  text: `${userM.name}`,
                  description: `${user.username}`,
                  iconName: 'user-profile',
                  items: [
                    // { id: 'profile', text: 'Profile' },
                    // { id: 'changePassword', text: 'Change Password' },
                    { id: 'preferences', text: 'Settings' },
                    { id: 'logout', text: 'Log Out' }
                  ],
                  onItemClick: (item) => logoutLocal(item)
                }
              ]
            : []
        }
      />
      {showNotificationPanel && (
        <div
          ref={notificationPanelRef}
          style={{
            position: 'absolute',
            top: '60px',
            right: '16px',
            zIndex: 9999,
            background: 'white',
            border: '1px solid #ccc',
            borderRadius: '10px',
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
            padding: '1rem',
            width: '40%',
            maxHeight: '50vh',
            overflowY: 'scroll',
            scrollbarWidth: 'none'
          }}
        >
          <div className="flex justify-between items-center mb-2">
            <h4 className="text-lg font-semibold">Notifications</h4>
            <div className="flex justify-even items-center">
              <span>
                <Settings
                  onClick={() => navigate('/app/user-preferences')}
                  size={16}
                />
              </span>
              <button
                onClick={() => setShowNotificationPanel(false)}
                className="text-gray-500 hover:text-gray-800 text-2xl ml-4"
              >
                &times;
              </button>
            </div>
          </div>
          <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
            {notifications.notifications.some((note) => !note.read) && (
              <>
                <li className="text-xs font-semibold text-gray-500 uppercase mb-1">
                  Unread
                </li>
                {notifications.notifications
                  .filter((note) => !note.read)
                  .map((note) => (
                    <li
                      key={note._id}
                      className="p-3 border-b last:border-none hover:bg-gray-100 transition-colors grid grid-cols-[auto_1fr_auto_auto] items-start gap-3 min-w-0"
                    >
                      <span className="mt-1">
                        <Mail />
                      </span>
                      <p className="text-sm text-gray-800 break-words">
                        {note.message}
                      </p>
                      <p>
                        {format(new Date(note.createdAt), 'ddd, MMM DD YYYY')}
                      </p>
                      <div className="flex items-center gap-2 justify-end">
                        {note.message.trim() !==
                          'The Documents were deleted' && (
                          <ViewButton notification={note} />
                        )}
                        <button
                          className="text-gray-400 hover:text-red-500 text-md"
                          title="Dismiss"
                          onClick={() =>
                            notifications.deleteNotification(note._id)
                          }
                        >
                          &times;
                        </button>
                      </div>
                    </li>
                  ))}
              </>
            )}

            {notifications.notifications.some((note) => note.read) && (
              <>
                <li className="text-xs text-gray-500 font-semibold uppercase mt-2 mb-1">
                  Read
                </li>
                {notifications.notifications
                  .filter((note) => note.read)
                  .map((note) => (
                    <li
                      key={note._id}
                      className="p-3 border-b last:border-none hover:bg-gray-100 transition-colors grid grid-cols-[auto_1fr_auto_auto] items-start gap-3 min-w-0"
                    >
                      <span className="mt-1">
                        <MailOpen />
                      </span>
                      <p className="text-sm text-gray-800 break-words">
                        {note.message}
                      </p>
                      <p>
                        {format(new Date(note.createdAt), 'ddd, MMM DD YYYY')}
                      </p>
                      <div className="flex items-center gap-2 justify-end">
                        {note.message.trim() !==
                          'The Documents were deleted' && (
                          <ViewButton notification={note} />
                        )}
                        <button
                          className="text-gray-400 hover:text-red-500 text-lg"
                          title="Dismiss"
                          onClick={() =>
                            notifications.deleteNotification(note._id)
                          }
                        >
                          &times;
                        </button>
                      </div>
                    </li>
                  ))}
              </>
            )}
          </ul>
        </div>
      )}
    </>
  );
};
